module.exports = __webpack_public_path__ + "static/industria_comercio-297b239340e47f3517cefec40fd819cb.png";